import history from '../../../../../history'
import isEmpty from 'lodash/isEmpty'
import { useDispatch, useSelector } from 'react-redux'
import { selectClientHomes, selectClientId } from '../../../../../store/selectors/client'
import {
  setListItemLoading,
  setClickedListItem,
  selectListItemLoading,
  selectClickedListItem,
  setMobileNavIsOpen
} from '../../../../../store/slices/nav'
import { routeToHome } from '../../../../../store/selectors/routes'
import { selectActiveItem } from '../../../../../store/selectors/navigation'
import { NAVIGATION_DELAY } from '../../../../../constants/navigation'
import { Text } from '../../../../../Components'
import { DropdownItem } from '../../../../../Components/shared/Navbar/Dropdown/DropdownItem'
import { SvgWrapper } from '../../../../../Components/shared/Navbar/SvgWrapper'
import { Spinner } from '../../../../../Components/shared/Navbar/Spinner'
import { ListItem } from '../../../../../Components/shared/Navbar/ListItem'
import { HomeSvg } from '../../../../../svgs'
import styles from './SharedHomeLinks.module.scss'

export interface SharedHomeLinkProps {
  isMobile?: boolean
}

export const SharedHomeLinks = ({ isMobile }: SharedHomeLinkProps) => {
  const dispatch = useDispatch()

  const homes = useSelector(selectClientHomes)
  const clientId = useSelector(selectClientId)
  const clickedListItem = useSelector(selectClickedListItem)
  const loading = useSelector(selectListItemLoading)
  const activeDropdownItem = useSelector(selectActiveItem)

  const handleOnClick = homeId => {
    dispatch(setClickedListItem(homeId))
    dispatch(setListItemLoading(true))

    setTimeout(() => {
      isMobile && dispatch(setMobileNavIsOpen(false))
      dispatch(setListItemLoading(false))
      history.push(routeToHome(clientId, homeId))
    }, NAVIGATION_DELAY)
  }

  const renderSvgOrLoading = home => {
    if (loading && clickedListItem === home.id) {
      return <Spinner />
    }

    return (
      <SvgWrapper>
        <HomeSvg />
      </SvgWrapper>
    )
  }

  const Element = isMobile ? ListItem : DropdownItem

  if (isEmpty(homes)) {
    return null
  }

  return homes?.map(home => {
    return (
      <Element
        isActive={activeDropdownItem === home.id && !loading}
        onClick={() => handleOnClick(home.id)}
        key={home.id}
      >
        {renderSvgOrLoading(home)}
        <Text
          className={styles.address}
          element='span'
          variant='neutralWarm'
          variantCount='700'
          weight='semibold'
          key={home.id}
        >
          {home?.address?.street}
        </Text>
      </Element>
    )
  })
}
